import { OrderType } from '../../../proxy/orders/enums';

export interface NewOrderConfiguration {
  orderTypes: readonly OrderType[];
  showEstablishment: boolean;
  showOrigin: boolean;
  showDestination: boolean;
  workflow: 'contractor' | 'silviculture';
  returnPath: string;
}

export const NEW_ORDER_CONFIGURATIONS = {
  contractor: {
    orderTypes: [OrderType.Order, OrderType.Return],
    showEstablishment: true,
    showOrigin: false,
    showDestination: false,
    workflow: 'contractor',
    returnPath: '/orders/contractor',
  },
  silviculture: {
    orderTypes: [OrderType.Order],
    showEstablishment: false,
    showOrigin: true,
    showDestination: true,
    workflow: 'silviculture',
    returnPath: '/orders/silviculture',
  },
} as const satisfies Record<string, NewOrderConfiguration>;
